import { GET_SINGLE_PLANS } from "./../graphql/queries/getAllSinglePlans"
import { useQuery } from "@apollo/client"
import { GET_SUGGESTED_USERS } from "../graphql/queries/getSuggestedUsers"

export const useSuggestedMembers = (group: number | string, search?: string) => {
  const { data, error, loading, refetch } = useQuery(GET_SUGGESTED_USERS, {
    variables: {
      group: group,
      first: undefined,
      skip: undefined,
      search: search,
    },
  })
  return { suggestedUsers: data?.suggestedUsers, error, loading, refetch }
}
